import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function Layout() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-[#FAFAFA] text-[#1C1C1C]">
      {/*
        SVG filter "brand-light": makes dark logo text light, keeps red strong.
        Matrix logic (linear in RGB):
          R' = 0.92                  (constant strong red, regardless of input)
          G' = -1 * R + 1            (R high -> G low ; R low -> G high)
          B' = -1 * R + 1            (same as G)
          A' = A                     (preserve transparency)
        Effect: red pixels stay red; dark/grey pixels become near-white.
      */}
      <svg aria-hidden="true" focusable="false" style={{ position: "absolute", width: 0, height: 0, overflow: "hidden" }}>
        <defs>
          <filter id="brand-light" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="
                0 0 0 0 0.92
                -1 0 0 0 1
                -1 0 0 0 1
                0 0 0 1 0"
            />
          </filter>
        </defs>
      </svg>

      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
